import { render, staticRenderFns } from "./deptTree.vue?vue&type=template&id=fb5cfbe6&scoped=true&"
import script from "./deptTree.vue?vue&type=script&lang=js&"
export * from "./deptTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5cfbe6",
  null
  
)

export default component.exports